<!-- Prettier bräche vor „.“ um, das würde als Leerzeichen sichtbar. -->
<!-- prettier-ignore -->
<p class="ki-maskierung__text">
  {{ 'settings.ki.maskierung.textVor' | translate }} <code>[KUNDENNR]</code>{{ 'settings.ki.maskierung.textNach' | translate }}
</p>
<p class="ki-maskierung__immer">
  {{ 'settings.ki.maskierung.immerAktiv' | translate }}
  <strong>{{ 'settings.ki.maskierung.kategorien' | translate }}</strong>
</p>
<div class="ki-maskierung__liste" data-testid="ki-settings-muster">
  @for (m of muster(); track $index; let i = $index) {
    @let grund = meldungen().get(m);
    <div class="ki-maskierung__zeile">
      <code
        class="ki-maskierung__muster"
        data-testid="ki-settings-muster-zeile"
        [class.ki-maskierung__muster--fehler]="!!grund"
        [attr.title]="m"
        [attr.aria-describedby]="grund ? 'ki-muster-fehler-' + i : null"
      >
        {{ m }}
      </code>
      <button
        type="button"
        class="ki-maskierung__entfernen"
        [attr.aria-label]="'settings.ki.maskierung.entfernen' | translate"
        [attr.aria-describedby]="grund ? 'ki-muster-fehler-' + i : null"
        (click)="onEntfernen(i)"
      >
        <mat-icon aria-hidden="true">delete_outline</mat-icon>
      </button>
    </div>
    @if (grund) {
      <div
        class="ki-maskierung__fehler"
        role="alert"
        data-testid="ki-settings-muster-fehler"
        [id]="'ki-muster-fehler-' + i"
      >
        {{ grund }}
      </div>
    }
  }
  <div class="ki-maskierung__zeile ki-maskierung__zeile--neu">
    <input
      class="ki-maskierung__feld"
      type="text"
      spellcheck="false"
      data-testid="ki-settings-muster-neu"
      [value]="neu()"
      [disabled]="voll()"
      [attr.maxlength]="maxLaenge"
      [placeholder]="'settings.ki.maskierung.platzhalter' | translate"
      [attr.aria-label]="'settings.ki.maskierung.neuLabel' | translate"
      [attr.aria-invalid]="!!neuFehler()"
      [attr.aria-describedby]="neuFehler() ? 'ki-muster-neu-fehler' : null"
      (input)="onNeu($event)"
      (keydown.enter)="onHinzufuegen()"
    />
    <button
      mat-stroked-button
      type="button"
      class="ki-maskierung__hinzufuegen"
      data-testid="ki-settings-muster-hinzufuegen"
      [disabled]="voll()"
      (click)="onHinzufuegen()"
    >
      {{ 'settings.ki.maskierung.hinzufuegen' | translate }}
    </button>
  </div>
  @if (neuFehler(); as key) {
    <div
      class="ki-maskierung__fehler"
      id="ki-muster-neu-fehler"
      role="alert"
      data-testid="ki-settings-muster-neu-fehler"
    >
      {{ key | translate }}
    </div>
  }
  @if (voll()) {
    <div class="ki-maskierung__maximum" data-testid="ki-settings-muster-maximum">
      {{ 'settings.ki.maskierung.maximum' | translate }}
    </div>
  }
</div>
